import type { CartItemFC } from "#modules/cart/types/cartItem.type"

import React from "react"
import Image from "next/image"
import { twJoin } from "tailwind-merge"

import { Price } from "#modules/cart/items/price"
import { CartItemRemoveButton } from "#modules/cart/items/removeItemButton.client"

// TODO abstract base of CartItem and PopupCartItem => quite similar
export const CartItem: CartItemFC = ({ cartItem, unModifiable, optimisticPending }) => {
  return (
    <article className={twJoin("flex flex-col justify-between transition-opacity sm:flex-row sm:items-center", optimisticPending && "opacity-40")}>
      {/*TODO show fallback image & fallback altText */}
      <div className="flex items-center">
        <Image
          // @ts-ignore
          src={cartItem.artwork.previewImages[0].url ?? ""}
          // @ts-ignore
          alt={cartItem.artwork.previewImages[0].alternativeText ?? ""}
          className="mr-10 h-[80px] min-h-[80px] w-[80px] min-w-[80px] rounded-lg object-cover sm:mr-8 sm:h-22 sm:min-h-22 sm:min-w-22 md:min-h-28 md:min-w-28 xl:mr-16 2xl:min-h-36 2xl:min-w-36"
          width={92}
          height={92}
        />
        <div>
          <h6 className="line-clamp-1 text-ellipsis text-nm font-bold sm:text-bg 2xl:text-sub">{cartItem.artwork.name}</h6>
          <p className="mt-px text-[12px] sm:text-[10px] md:text-[12px] xl:text-nm 2xl:font-bold">{cartItem.artwork.artist?.fullName}</p>
          <p className="mt-4 text-[10px] text-gray-50 xl:text-[12px]">{`${cartItem.artwork.width} x ${cartItem.artwork.height} cm`}</p>
          <p className="mt-px text-[10px] text-gray-50 xl:text-[12px]">{cartItem.artwork.technique}</p>
        </div>
      </div>
      <div className="relative mt-6 flex w-full items-end justify-between pl-[120px] before:absolute before:left-0 before:block before:h-6 before:border-r-2 before:border-r-current sm:w-auto sm:gap-9 sm:pl-0 sm:before:content-none">
        <Price price={cartItem.artwork.price} className={"flex flex-col text-[10px] font-semibold xl:text-[12px]"} priceClassName={"mt-0.5 text-[10px] font-bold md:text-nm"} />
        {!unModifiable && (
          <CartItemRemoveButton
            artworkId={cartItem.artwork.id}
            disabled={optimisticPending}
            classNames={"text-current hover:text-gold-100"}
            disabledClassNames={"hover:text-current"}
          />
        )}
      </div>
    </article>
  )
}
